import { render } from "./TheUnauthorized.vue?vue&type=template&id=75b76b2c&scoped=true"
import script from "./TheUnauthorized.vue?vue&type=script&lang=js"
export * from "./TheUnauthorized.vue?vue&type=script&lang=js"

import "./TheUnauthorized.vue?vue&type=style&index=0&id=75b76b2c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-75b76b2c"

export default script